module.exports = __webpack_public_path__ + "img/02-03_Being composed.0a46f40c.svg";